import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
const { Option } = Select;

function BugByMonth({ barChartOption, projects }) {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [barChartData, setbarChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(moment());
    const [assignee, setAssignee] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        range_year: moment().get("year"),
        project_id: -1,
    });

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => {
            return await HTTP("/analytics/getJiraAssignees", { staff_id });
        },
        { enabled: false },
    );
    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "bugByMonths",
        async () => {
            return await HTTP("/analytics/getJiraBugsByMonth", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);

    useEffect(() => {
        getChart();
    }, [formData]);

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        if (chartStatus === "success") {
            const { data: chartData } = chartRes;
            setbarChartData(chartData);
        }
    }, [chartStatus, chartRes]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const updatedFormData = {
            ...formData,
            range_year: yearSelected,
        };
        setFormData(updatedFormData);
    }

    function handleProjectSelectionChange(e) {
        let project_id = -1;
        if (e !== undefined) {
            [project_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            project_id,
        };
        setFormData(updatedFormData);
    }

    function handleAssigneeSelectionChange(e) {
        let workauthor_id = "";
        if (e !== undefined) {
            [workauthor_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            workauthor_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    className="jira-dashboard-select"
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {barChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="ColumnChart"
                    height="50vh"
                    options={{
                        ...barChartOption,
                        vAxis: {
                            ...barChartOption.vAxis,
                            // viewWindowMode: "explicit",
                            viewWindow: { min: 0 },
                        },
                        title: "Bugs By Months",
                    }}
                    data={barChartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default BugByMonth;
